import React, { Component, Fragment } from 'react'
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { RESET_REGISTER } from '../../../utils/constants/actionTypes';

import Logo from '../../../components/atoms/Logo';
import Label from '../../../components/atoms/Label';
import Steps from '../../../components/molecules/Steps';
import ModalInformation from '../../organism/ModalInformation';

//Steps Register
import StepNoPonsel from '../../organism/register/StepNoPonsel'
import StepOtp from '../../organism/register/StepOtp'
import StepEmail from '../../organism/register/StepEmail'

//Action Redux
import {RegisterNoPonsel} from '../../../redux/actions/Register'
import { RegisterEmail } from '../../../redux/actions/Register';
import {VerifyNoPonsel, ResendOtp} from '../../../redux/actions/Register'
import ModalRegister from '../../organism/ModalRegister';

class Register extends Component {
    constructor(props){
        super(props);

        this.state = {
            steps : {
                list : ['Nomor Ponsel', 'OTP', 'Surel'],
                active : 0
            }
        }
    }

    setActiveSteps = (index) => {
        this.setState({
            steps : {
                ...this.state.steps,
                active : index
            }
        })
    }


    getDisplay = (active) => {
        switch(active){
            case 0 :  return <StepNoPonsel {...this.props} onSubmit={this.setActiveSteps} />
            case 1 :  return <StepOtp {...this.props} onSubmit={this.setActiveSteps} />
            case 2 :  return <StepEmail {...this.props} onSubmit={this.setActiveSteps} />
            default :
                return <Redirect to='/'></Redirect>
        }
    }

    componentDidMount = () => {
		document.title = 'KlikCair - Register Pemberi Pinjaman'
        this.props.ResetDataRegister();
        
    }

    render () {
        const{steps} = this.state;
        const modalProps = {
            show : this.props.regState.isFinish,
            title : 'Surel Verifikasi telah dikirimkan',
            content : 'Segera verifikasi surel Anda dengan membuka tautan yang telah dikirimkan. Apabila Anda tidak menerima surel verifikasi, silakan menghubungi info@klikcair.com untuk bantuan lebih lanjut.',
            icon : './img/icon/icon-verifikasi-email.png',
            actYes : {
                title : 'SELESAI',
                action : () => { this.props.history.replace('/login') }
            },
            actNo : null,
            actClose : ()=>{ this.props.history.replace('/login') }
        }
        
        return (
            <Fragment>
                <div className='register-wrapper container'>
                    <Logo />
                    
                    <Label type='title' className='label-kc-s mt-5 mb-2' value='Daftar Sebagai Peminjam' />

                    <div className='d-flex justify-content-center align-items-center mb-5'>
                        <Label type='paragraph' value='Sudah memiliki akun ?' />
                        <Label type='paragraph' className='blue ml-1 link' onClick={() => {this.props.history.push('/login')}} value='Masuk' />
                    </div>

                    <div className='box-register d-flex flex-column justify-content-center align-items-center'>
                        <Steps onClick={()=>{}} list={steps.list} active={steps.active}  />

                        <div className='form-container'>
                            {this.getDisplay(steps.active)}
                        </div>
                    </div>
                </div>
                
                <ModalInformation {...modalProps} />


                <ModalRegister />
            </Fragment>
        )
    }
}



const mapStateToProps = state => {
    return {
        status : state.statusState,
        regState : state.registerState
    }
}

const mapDispatchToProps = dispatch => {
    return {
        ResetDataRegister : () => {
            dispatch({type : RESET_REGISTER});
        },
        RegisterNoPonsel : data => {
            return dispatch(RegisterNoPonsel(data))
        },
        VerifyNoPonsel : data => {
            return dispatch(VerifyNoPonsel(data))
        },
        ResendOtp : token => {
            return dispatch(ResendOtp(token))
        },
        RegisterEmail : data => {
            return dispatch(RegisterEmail(data))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Register);